  <div class="row mt-3">
    <div class="col-sm-12">

      <div class="row">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-alert-message [errorType]="'error'"
            [message]="'Review your Quote, and Approve once done. Quote will only be processed once Approved.'">
          </tan-alert-message>
        </div>
      </div>

      <ng-container *ngIf="activeStep == 0">
        <div class="row justify-content-center">
          <div class="col-sm-12 d-flex justify-content-center">
            <span>Would you like to Confirm Customer Details, or proceed to Confirm Quote and approve?</span>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-sm-12 d-flex justify-content-center">
            <button type="button" class="btn btn-secondary ml-2 mr-2 mt-1 diagram-btn"
              (click)="openApproveCustomerScreen()">
              Confirm Customer Details
            </button>
            <button type="button" class="btn btn-secondary ml-2 mr-2 mt-1 diagram-btn"
              (click)="openApproveQuoteScreen()">
              Confirm Quote
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="activeStep == 1">
        <div class="row justify-content-center" *ngIf="(updateQuoteLoading$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not update Quote'"></tan-alert-message>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="container custom-section">
              <div class="row mt-2">
                <div class="col-sm-8">
                  <span class="section-heading">{{ quote.quoteNumber }} - {{ quote.customer.firstName }}
                    {{ quote.customer.lastName }} - {{ quote.customer.company.name }}</span>
                </div>
                <div class="col-sm-4 text-right">
                  <button type="button" class="btn btn-primary add" (click)="updateCustomerQuote()">
                    <span>Update details</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container custom-section">
          <div class="row">
            <div class="col-sm-12">
              <span class="section-heading">Basic details</span>
            </div>
          </div>

          <form class="mt-3" [formGroup]="quoteForm">
            <div class="row form-group" *ngIf="isStaff">
              <div class="col-sm-9">
                <label class="control-label" for="customer">Customer</label>
                <input type="text" class="form-control" formControlName="customer"
                  placeholder="Please select a customer">
              </div>
              <div class="col-sm-3 top-margin">
                <div class="btn-group fr">
                  <button id="CustomersByButton" type="button" class="btn btn-primary dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span>Search Customer</span>
                  </button>
                  <div class="dropdown-menu p-0 dropdown-menu-position" aria-labelledby="CustomersByButton">
                    <div class="dropdown-divider m-0"></div>
                    <div class="form-group select-margin-bottom search-dropdown-box p-1 m-0">
                      <input class="form-control" id="search-text" type="text" formControlName="searchCustomer"
                        [(ngModel)]="searchText" (ngModelChange)="searchCustomers()" placeholder="Search customers" />
                    </div>
                    <div class="dropdown-divider m-0"></div>
                    <div class="search-items">
                      <tan-loader [loading]="(customersLoading$ | async)" [loadingText]="'<p>Searching customers</p>'">
                      </tan-loader>
                      <div *ngIf="!(customersLoading$ | async) && customers.length > 0">
                        <button class="dropdown-item" (click)="setSelectedCustomer(customer)"
                          *ngFor="let customer of customers">
                          {{ customer.firstName }} {{ customer.lastName }}</button>
                      </div>
                      <div *ngIf="!(customersLoading$ | async) && customers.length == 0">
                        <button class="dropdown-item">No customers found</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label" for="building_type">Building Type</label>
              <select class="form-control" formControlName="building_type" id="building_type"
                (change)="setBuildingType()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let building of buildingTypes" [ngValue]="building.id">{{ building.name }}</option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('building_type').touched && quoteForm.get('building_type').errors?.required">
                Building Type is required</span>
            </div>

            <div class="form-group">
              <label class="control-label" for="organization_sector">Organizational Sector</label>
              <select class="form-control" formControlName="organization_sector" id="organization_sector"
                (change)="setOrganizationalSector()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let org of organizationalTypes" [ngValue]="org.id">{{ org.name }}</option>
              </select>
              <span class="error"
                *ngIf="quoteForm.get('organization_sector').touched && quoteForm.get('organization_sector').errors?.required">
                Organizational Sector is required</span>
            </div>

            <div class="form-group">
              <label class="control-label" for="notes">Notes</label>
              <input type="text" class="form-control" formControlName="notes" />
            </div>

          </form>
        </div>

        <div class="container custom-section">
          <div class="row mt-2">
            <div class="col-sm-12">
              <span class="section-heading">Delivery and Collection Area</span>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-sm-12">
              <span class="guidance-text">This is the address where the modular building(s) will be delivered to</span>
            </div>
          </div>

          <form class="mt-3" [formGroup]="addressForm">

            <div class="form-group">
              <label class="control-label" for="shipping_address1">Address line 1</label>
              <input type="text" class="form-control" formControlName="shipping_address1" />
              <span class="error"
                *ngIf="addressForm.get('shipping_address1').touched && addressForm.get('shipping_address1').errors?.required">
                Address line 1 is required</span>
            </div>

            <div class="form-group">
              <label class="control-label" for="shipping_address2">Address line 2</label>
              <input type="text" class="form-control" formControlName="shipping_address2" />
              <span class="error"
                *ngIf="addressForm.get('shipping_address2').touched && addressForm.get('shipping_address2').errors?.required">
                Address line 2 is required</span>
            </div>

            <div class="form-group">
              <label class="control-label" for="shipping_suburb">Suburb</label>
              <input type="text" class="form-control" formControlName="shipping_suburb" />
              <span class="error"
                *ngIf="addressForm.get('shipping_suburb').touched && addressForm.get('shipping_suburb').errors?.required">
                Suburb is required</span>
            </div>

            <div class="row mt-2" *ngIf="!changeDeliveryArea">
              <label class="col-sm-12 col-form-label">
                Current selected Delivery area
              </label>
              <div class="col-sm-12">
                <span class="guidance-text">{{ selectedDeliveryArea }}</span>
              </div>
            </div>

            <div class="row mb-2" *ngIf="showProvinceMsg">
              <div class="col-sm-12">
                <span class="guidance-text">Collection of units quoted Ex-Works Kwikspace</span> <br>
                <span class="guidance-text">**An experienced sales consultant will be in contact with you to confirm
                  your delivery location
                  and
                  if/where required, and provide a revised quotation**</span>
              </div>
            </div>

            <div class="form-group">
              <label class="control-label" for="shipping_postal">Postal code</label>
              <input type="text" class="form-control" formControlName="shipping_postal" />
            </div>

          </form>
        </div>

      </ng-container>

      <ng-container *ngIf="activeStep == 2">
        <tan-loader [loading]="(quoteLoading$ | async)" [loadingText]="'<p>Getting quote</p>'">
        </tan-loader>

        <div class="row justify-content-center"
          *ngIf="(createProductConfigurationError$ | async) || (createLineItemError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not create Quote'"></tan-alert-message>
          </div>
        </div>

        <div class="row justify-content-center" *ngIf="!(quoteLoading$ | async) && (quoteError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not retrieve Quote'"></tan-alert-message>
          </div>
        </div>

        <ng-container *ngIf="!(quoteLoading$ | async) && !(quoteError$ | async)">
          <div class="row">
            <div class="col-sm-12">
              <div class="container custom-section">
                <div class="row">
                  <div class="col-sm-8">
                    <span class="section-heading">{{ quote.quoteNumber }} - {{ quote.customer.firstName }}
                      {{ quote.customer.lastName }} - {{ quote.customer.company.name }}</span>
                  </div>
                  <div class="col-sm-4 text-right" *ngIf="canApprove && quote.lineItems.length > 0 && !canUpdateStatus">
                    <button type="button" class="btn btn-primary add" (click)="updateQuote()">
                      <span>Approve</span>
                    </button>
                  </div>
                  <div class="col-sm-4 text-right" *ngIf="canUpdateStatus">
                    <button type="button" class="btn btn-primary add" (click)="updateQuoteStatus()">
                      <span>Change status</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="container custom-section">

                <div class="row" *ngIf="quote.lineItems.length == 0">
                  <div class="col-sm-12">
                    <tan-alert-message [errorType]="'info'" [message]="'No items added to quote'"></tan-alert-message>
                  </div>
                </div>

                <ng-container *ngIf="quote.lineItems.length == 0">
                  <div class="row">
                    <div class="col-sm-12 d-flex justify-content-center">
                      <button type="button" class="btn btn-primary add" (click)="addUnit()">
                        <span>Add Unit</span>
                      </button>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="quote.lineItems.length > 0">
                  <div class="row col-heading">
                    <div class="col-sm-2">
                      No.
                    </div>
                    <div class="col-sm-4">
                      Description
                    </div>
                    <div class="col-sm-2 d-flex justify-content-center">
                      QTY
                    </div>
                    <div class="col-sm-4 d-flex justify-content-center">
                      Actions
                    </div>
                  </div>

                  <ng-container *ngFor="let item of quote.lineItems">
                    <div class="row mt-2">
                      <div class="col-sm-8">
                        {{ item.name }}
                      </div>
                      <div class="col-sm-4 text-right">
                        <button type="button" class="btn btn-primary add" (click)="addUnit()">
                          <span>Add Unit</span>
                        </button>
                        <button type="button" class="btn btn-primary edit ml-1" (click)="editLineItem(item)">
                          <span><i class="fa fa-pencil"></i></span>
                        </button>
                        <button type="button" class="btn btn-primary remove ml-1" (click)="openRemoveUnitModal(item)">
                          <span><i class="fa fa-trash"></i></span>
                        </button>
                        <ng-container *ngIf="!isCustomer && isStaff">
                          <button type="button" class="btn btn-primary add ml-1" (click)="applyLineItemDiscount(item)">
                            <span>Apply Discount</span>
                          </button>
                        </ng-container>
                      </div>
                    </div>
                    <!-- Rental price rows -->
                    <div class="row item-row mt-2">
                      <div class="col-sm-2"></div>
                      <div class="col-sm-4">
                        {{ item.rentalOption.name }}
                      </div>
                      <div class="col-sm-2 d-flex justify-content-center">
                        {{ item.quantity }}
                      </div>
                      <div class="col-sm-4 text-right">
                      </div>
                    </div>

                    <!-- Product addon price rows -->
                    <div class="row item-row mb-1 mt-2">
                      <div class="col-sm-2"></div>
                      <div class="col-sm-6">
                        <label class="col-form-label">
                          Optional Extra(s)
                        </label>
                      </div>
                      <div class="col-sm-4 text-right">
                        <button type="button" class="btn btn-primary add" (click)="addExtraToLineItem(item)">
                          <span>Add Extra</span>
                        </button>
                      </div>
                    </div>
                    <ng-container *ngIf="item.productConfigurations.length > 0">
                      <div class="row item-row extras-row mb-1 mt-2" *ngFor="let addon of item.productConfigurations">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-4 row-item-pad">
                          {{ addon.product.name }}
                        </div>
                        <div class="col-sm-2 d-flex justify-content-center">
                          {{ addon.quantity }}
                        </div>
                        <div class="col-sm-4 text-right">
                          <button type="button" class="btn btn-primary edit" (click)="openEditExtraModal(item, addon)">
                            <span><i class="fa fa-pencil"></i></span>
                          </button>
                          <button type="button" class="btn btn-primary remove ml-1 "
                            (click)="openRemoveExtraModal(item, addon)">
                            <span><i class="fa fa-trash"></i></span>
                          </button>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Delivery price rows -->
                    <div class="row item-row mt-2">
                      <div class="col-sm-2"></div>
                      <div class="col-sm-6">
                        <label class="col-form-label">
                          Travel charge(s)
                        </label>
                      </div>
                      <div class="col-sm-4 text-right" *ngIf="!isCustomer && isStaff">
                        <button type="button" class="btn btn-primary add" (click)="editTransportCharge(item)">
                          <span>Modify Charge</span>
                        </button>
                      </div>
                    </div>
                    <div class="row item-row mt-2" *ngIf="item.deliveryCharge">
                      <div class="col-sm-2"></div>
                      <div class="col-sm-4">
                        {{ item.deliveryCharge.transportCharge.name }} -
                        {{ item.deliveryCharge.transportLocation.district.name }} -
                        {{ item.deliveryCharge.transportLocation.name }}
                      </div>
                      <div class="col-sm-2 d-flex justify-content-center">
                        {{ item.quantity }}
                      </div>
                      <div class="col-sm-4 text-right"></div>
                    </div>
                    <div class="row item-row mt-2" *ngIf="item.deliveryChargeDiscounted">
                      <div class="col-sm-2"></div>
                      <div class="col-sm-4">
                        {{ item.deliveryChargeDiscounted.transportCharge }} -
                        {{ item.deliveryChargeDiscounted.transportLocation }}
                      </div>
                      <div class="col-sm-2 d-flex justify-content-center">
                        {{ item.quantity }}
                      </div>
                      <div class="col-sm-4 text-right"></div>
                    </div>


                  </ng-container>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>
  </div>

  <tan-modal #optionalExtraModal [size]="'lg'" [title]="'Add Extra'" [showInformationBlock]="false"
    (onSave)="addOptionalExtraToLineItem()" (closeModal)="resetForms()" [isDisabled]="extrasFormIsDisabled">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(productsLoading$ | async)"
          [loadingText]="'<p>Fetching products</p>'">
        </tan-loader>

        <tan-loader [loading]="(createProductConfigurationLoading$ | async)"
          [loadingText]="'<p>Saving optional extra</p>'">
        </tan-loader>

        <div class="row" *ngIf="(createProductConfigurationError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'info'" [message]="'Could not save Optional extra to quote.'">
            </tan-alert-message>
          </div>
        </div>
        
        <div *ngIf="!(productsLoading$ | async) && filteredProducts.length === 0 && !noProductsAvailable">
            <tan-alert-message [errorType]="'info'" [message]="'Already added all available extras to unit.'">
            </tan-alert-message>
        </div>

        <div *ngIf="!(productsLoading$ | async) && filteredProducts.length == 0 && noProductsAvailable" class="mt-2">
          <tan-alert-message [errorType]="'info'" [message]="'No optional extras found for this unit.'">
          </tan-alert-message>
        </div>

        <form class="mt-3" [formGroup]="extrasForm" *ngIf="!(productsLoading$ | async) && filteredProducts.length > 0">
          <div class="row form-group">
            <div class="col-sm-12">
              <label class="control-label" for="product_dropdown">Select Product</label>
              <select class="form-control" id="product_dropdown" formControlName="product" (change)="setProduct()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let product of filteredProducts" [ngValue]="product.id">{{ product.name }}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label class="control-label" for="quantity">Quantity</label>
            <input type="text" class="form-control" formControlName="quantity"
              (ngModelChange)="validateLimitation($event)"  min="0" oninput="validity.valid||(value='')"/>
            <span class="info guidance-text-blue">Enter quantity required <strong>per unit</strong></span><br>
            <span class="info guidance-text" *ngIf="limitationError">Quantity cannot exceed {{ limitaion }} items for
              this unit</span>
          </div>

        </form>
      </div>
    </div>
  </tan-modal>

  <tan-modal #editOptionalExtraModal 
    [size]="'lg'" 
    [title]="'Edit Extra'" 
    [showInformationBlock]="false"
    (closeModal)="resetForms()"
    (onSave)="editOptionalExtra()" 
    [isDisabled]="extrasFormIsDisabled">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(productsLoading$ | async)"
          [loadingText]="'<p>Fetching products</p>'">
        </tan-loader>

        <tan-loader [loading]="(updateProductConfigurationLoading$ | async)"
          [loadingText]="'<p>Saving optional extra</p>'">
        </tan-loader>

        <div class="row" *ngIf="(updateProductConfigurationError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'info'" [message]="'Could not save Optional extra to quote.'">
            </tan-alert-message>
          </div>
        </div>

        <form class="mt-3" [formGroup]="extrasForm" *ngIf="!(productsLoading$ | async)">
          <div class="row form-group">
            <div class="col-sm-12">
              <label class="control-label" for="product_dropdown">Selected Product</label>
              <input type="text" 
                readonly 
                class="form-control-plaintext" 
                [ngModelOptions]="{standalone: true}" 
                [ngModel]="selectedModalLineItemExtra?.product?.name">
            </div>
          </div>

          <div class="form-group">
            <label class="control-label" for="quantity">Quantity</label>
            <input type="text" class="form-control" formControlName="quantity"
              (ngModelChange)="validateLimitation($event)"  min="0" oninput="validity.valid||(value='')"/>
            <span class="info guidance-text-blue">Enter quantity required <strong>per unit</strong></span><br>
            <span class="info guidance-text" *ngIf="limitationError">Quantity cannot exceed {{ limitaion }} items for
              this unit</span>
          </div>

        </form>
      </div>
    </div>
  </tan-modal>

  <tan-modal #quoteApproveModal [size]="'md'" [title]="'Confirm'" [showInformationBlock]="false"
    [showActionButton]="false">
    <div modal-content>
      <div class="container">
        <div class="row">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'info'"
              [message]="'Review your Quote, and Approve once done. Quote will only be processed once Approved.'">
            </tan-alert-message>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>

  <tan-modal #addUnitModal 
    [size]="'lg'" 
    [title]="unitTitle" 
    [showInformationBlock]="false" 
    [isDisabled]="!showOptionDescription && 
      !(showTransport || !isSaProvince) || 
      preloadingEditForm ||
      transportOneLoading ||
      transportTwoLoading ||
      rentalMonthsError || 
      rentalLoading"
    (onSave)="saveUnit()"
    (closeModal)="resetForms()"
    [actionButtonBusy]="savingUnit">
    <div modal-content>
      <div class="container">
        <ng-container *ngTemplateOutlet="unitConfig;"></ng-container>
      </div>
    </div>
  </tan-modal>

  <ng-template #unitConfig let-item>
    <tan-loader [loading]="preloadingEditForm" [loadingText]="'<p>Fetching Unit Details</p>'">
    </tan-loader>

    <form class="mt-3" [formGroup]="rentalForm" *ngIf="!preloadingEditForm">
      <div class="row mt-2">
        <div class="col-sm-6" *ngIf="!additionalUnit">
          <div class="form-group">
            <label class="control-label" for="rental_period">Period</label>
            <select class="form-control" formControlName="rental_period" id="rental_period" (change)="setPeriod()">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let period of rentalPeriods" [ngValue]="period.id">{{ period.period }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="rental_size">Size</label>
            <select class="form-control" formControlName="rental_size" id="rental_size" (change)="setSize()">
              <option [ngValue]="null">Please select</option>
              <option *ngFor="let size of rentalSizes" [ngValue]="size.id">{{ size.size }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row mt-2" *ngIf="showRentalOptions">
        <div class="col-sm-6" *ngIf="!additionalUnit">
          <div class="form-group">
            <label class="control-label" for="rental_months">Actual Months</label>
            <input type="number" class="form-control" formControlName="rental_months"
              (ngModelChange)="validateMinMaxMonths()" [value]="actualMonths" />
            <span class="info guidance-text-blue">Actual months required for</span><br>
            <span class="error"
              *ngIf="rentalForm.get('rental_months').touched && rentalForm.get('rental_months').errors?.required">
              Actual months is required</span>
            <span class="error" *ngIf="rentalMonthsError">{{ rentalMonthsErrorMsg }}</span>
          </div>
        </div>
        <div class="col-sm-6" *ngIf="!showQty">
          <div class="mt-3">
            <tan-alert-message [errorType]="'info'" [message]="'Remove extras to change quantity.'"></tan-alert-message>
          </div>
        </div>
        <div class="col-sm-6" *ngIf="showQty">
          <div class="form-group">
            <label class="control-label" for="unit_qty">Quantity required</label>
            <input type="number" class="form-control" formControlName="unit_qty" (ngModelChange)="setUnitQty()"
              [value]="unitQty"   min="0" oninput="validity.valid||(value='')"/>
            <span class="info guidance-text-blue">How many of these (with same configuration) do you want?</span><br>
            <span class="error"
              *ngIf="rentalForm.get('unit_qty').touched && rentalForm.get('unit_qty').errors?.required">
              Qty is required</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showRentalOptions && !rentalMonthsError && qtyEntered">
        <tan-loader [loading]="(getRentalPriceListLoading$ | async)" [loadingText]="'<p>Loading pricing..</p>'">
        </tan-loader>

        <label class="control-label" for="rental_option" *ngIf="!hasPricing">Rental Option</label>
        <div class="row d-flex justify-content-center" *ngIf="!hasPricing">
          <div class="col-sm-12 d-flex justify-content-center">
            <button type="button" class="btn btn-primary action-btn" (click)="getRentalPriceList()">
              <span>Retry?</span>
            </button>
          </div>
        </div>

        <div class="form-group" *ngIf="!(getRentalPriceListLoading$ | async) && hasPricing">
          <label class="control-label" for="rental_option">Rental Option</label>
          <select class="form-control" formControlName="rental_option" id="rental_option" (change)="setRentalOption()">
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let option of rentalPricing" [ngValue]="option.id">{{ option.name }}</option>
          </select>
        </div>
      </ng-container>

      <div class="row" *ngIf="rentalLoading">
        <div class="col-sm-12 d-flex justify-content-center">
          <tan-loader [loading]="rentalLoading" [loadingText]="'<p>Finding travel charge</p>'">
          </tan-loader>
        </div>
      </div>

      <ng-container *ngIf="!isClassroom && showTransport && showTransportSize">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label" for="transport_load_one">* Truck Size</label>
              <select [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" class="form-control" formControlName="transport_load_one" id="transport_load_one"
                (change)="setSelectedTransportLoadOne()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let size of transportLoads" [ngValue]="size.id">
                  {{ size.size }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label" for="transport_load_one_qty">* Qty of Trucks required</label>
              <input [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" 
                type="number" 
                class="form-control"
                formControlName="transport_load_one_qty"
                (ngModelChange)="loadOneQtyUpdate.next($event)"/>
              <span class="error"
                *ngIf="rentalForm.get('transport_load_one_qty').touched && rentalForm.get('transport_load_one_qty').errors?.required">
                Qty is required</span><br>
            </div>
          </div>
          <tan-loader [loading]="transportOneLoading" [loadingText]="'<p>Calculating charges..</p>'">
          </tan-loader>
          <div class="row justify-content-center" 
            *ngIf="!transportOneLoading && 
                !transportOneHasPricing && 
                selectedTransportLoadOne?.load &&
                selectedTransportLoadOne?.quantity">
              <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message [errorType]="'error'" [message]="'No transport found for selected truck size'">
                  </tan-alert-message>
              </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isClassroom && showTransport && showTransportSize && addSecondTransportLoad">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label" for="transport_load_two">* Truck Size</label>
              <select [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" class="form-control" formControlName="transport_load_two" id="transport_load_two"
                (change)="setSelectedTransportLoadTwo()">
                <option [ngValue]="null">Please select</option>
                <option *ngFor="let size of transportLoads" [ngValue]="size.id">
                  {{ size.size }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="control-label" for="transport_load_two_qty">* Qty of Trucks required</label>
              <input [attr.disabled]="(transportOneLoading || transportTwoLoading) ? true : null" 
                type="number" 
                class="form-control" 
                formControlName="transport_load_two_qty" 
                (ngModelChange)="loadTwoQtyUpdate.next($event)"/>
              <span class="error"
                *ngIf="rentalForm.get('transport_load_two_qty').touched && rentalForm.get('transport_load_two_qty').errors?.required">
                Qty is required</span><br>
            </div>
          </div>
          <tan-loader [loading]="transportTwoLoading" [loadingText]="'<p>Calculating charges..</p>'">
          </tan-loader>
          <div class="row justify-content-center" 
              *ngIf="!transportTwoLoading && 
                  !transportTwoHasPricing && 
                  selectedTransportLoadTwo?.load &&
                  selectedTransportLoadTwo?.quantity">
              <div class="col-sm-12 d-flex justify-content-center">
                  <tan-alert-message [errorType]="'error'" [message]="'No transport found for selected truck size'">
                  </tan-alert-message>
              </div>
          </div>
        </div>
      </ng-container>

      <div class="row" *ngIf="!isClassroom">
        <div class="col-sm-12 ">
          <span class="guidance-text"><strong>Note:</strong></span><br>
          <span class="guidance-text">1. A single 3m/6m building could be transported on a 6m truck</span><br>
          <span class="guidance-text">2. A single 9m/12m building could be transported on a 12m truck</span><br>
          <span class="guidance-text">3. Two 6m buildings can be transported on a 12m truck</span><br>
          <span class="guidance-text">4. Two 3m building can be transported on a 6m truck</span><br>
          <span class="guidance-text">5. Classroom transport price calculated automatically</span><br>
          <span class="guidance-text">6. The transport price has been provided as an estimate, please contact a Kwikspace representative for discounted rates, where units can be placed on combined load/truck sizes.</span>
        </div>
      </div>

      <div class="row justify-content-center mt-3 mb-3" *ngIf="!isClassroom && showTransport && showTransportSize && !addSecondTransportLoad">
        <div class="col-sm-12 d-flex justify-content-center">
          <button type="button" class="btn btn-primary truck-btn" (click)="addAnotherTruck()">
            <span>Add another truck</span>
          </button>
        </div>
      </div>

      <div class="form-group mt-2" *ngIf="showTransportCharge">
        <ng-container>
          <tan-loader [loading]="(transportPricingLoading$ | async)" [loadingText]="'<p>Loading charges..</p>'">
          </tan-loader>

          <label class="control-label" for="rental_transport" *ngIf="!hasTransportPricing">Confirm Transport
            Charges</label>
          <div class="row d-flex justify-content-center" *ngIf="!hasTransportPricing">
            <div class="col-sm-12 d-flex justify-content-center">
              <button type="button" class="btn btn-primary action-btn" (click)="getTransportAllPricing()">
                <span>Retry?</span>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="!(transportPricingLoading$ | async) && !(transportPricingError$ | async) && hasTransportPricing">
          <label class="control-label" for="rental_transport">Confirm Transport Charges</label>
          <select class="form-control" formControlName="rental_transport" id="rental_transport"
            (change)="setTransportOption()">
            <option [ngValue]="null">Please select</option>
            <option *ngFor="let transport of transportPricing" [ngValue]="transport.id">
              {{ transport.transportLocation.district.name }} - {{ transport.transportLocation.name }} -
              {{ transport.transportCharge.name }}</option>
          </select>
        </ng-container>
      </div>

      <ng-container *ngIf="showOptionDescription">
        <div class="row">
          <label class="col-sm-12 col-form-label">
            You have selected the below option:
          </label>
        </div>
        <div class="row mb-2">
          <div class="col-sm-9">
            {{ selectedOption.category.name }} - {{ selectedOption.item.description }} -
            {{ selectedOption.size.size }} - {{ selectedOption.period.period }}
          </div>
        </div>
      </ng-container>
    </form>
  </ng-template>

  <ng-template #unitConfigClassroom let-item>
    <form class="mt-3" [formGroup]="rentalForm">
      <div class="form-group">
        <label class="control-label" for="rental_period">Period</label>
        <select class="form-control" formControlName="rental_period" id="rental_period" (change)="setPeriod()">
          <option [ngValue]="null">Please select</option>
          <option *ngFor="let period of rentalPeriods" [ngValue]="period.id">{{ period.period }}
          </option>
        </select>
      </div>

      <div class="row mt-2" *ngIf="showRentalOptions">
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label" for="rental_months">Actual Months</label>
            <input type="number" class="form-control" formControlName="rental_months"
              (ngModelChange)="validateMinMaxMonths()" [value]="actualMonths" />
            <span class="info guidance-text-blue">Actual months required for</span><br>
            <span class="error"
              *ngIf="rentalForm.get('rental_months').touched && rentalForm.get('rental_months').errors?.required">
              Actual months is required</span>
            <span class="error" *ngIf="rentalMonthsError">{{ rentalMonthsErrorMsg }}</span>
          </div>
        </div>
        <div class="col-sm-6" *ngIf="showQty">
          <div class="form-group">
            <label class="control-label" for="unit_qty">Quantity required</label>
            <input type="number" class="form-control" formControlName="unit_qty" (ngModelChange)="setUnitQty()"
              [value]="unitQty"  min="0" oninput="validity.valid||(value='')"/>
            <span class="info guidance-text-blue">How many of these (with same configuration) do you want?</span><br>
            <span class="error"
              *ngIf="rentalForm.get('unit_qty').touched && rentalForm.get('unit_qty').errors?.required">
              Qty is required</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showOptionDescription">
        <div class="row">
          <label class="col-sm-12 col-form-label">
            You have selected the below option:
          </label>
        </div>
        <div class="row mb-2">
          <div class="col-sm-9">
            {{ selectedOption.category.name }} - {{ selectedOption.item.description }} -
            {{ selectedOption.size.size }} - {{ selectedOption.period.period }}
          </div>
          <div class="col-sm-3 ar">
            <div ngbDropdown class="d-inline-block">
              <button class="btn btn-secondary table-filter-btn" id="viewDiagram" ngbDropdownToggle>
                <span class="fa fa-eye text-white"></span> View
              </button>
              <div ngbDropdownMenu aria-labelledby="viewDiagram" class="filter-dropdown">
                <button ngbDropdownItem (click)="showAblutions()">
                  Ablutions
                </button>
                <button ngbDropdownItem (click)="showOffices()">
                  Offices
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3 mb-2">
          <label class="col-sm-8 col-form-label" for="optional_extras">
            Do you wish to add any optional extras?
          </label>
          <div class="col-md-4">
            <input type="checkbox" class="form-control comparison-check form-input-check" [checked]="showOptionalExtras"
              formControlName="optional_extras" id="optional_extras" (click)="addExtras($event.target.checked)">
          </div>
        </div>

        <div class="row" *ngIf="showOptionalExtras">
          <div class="col-sm-12">
            <div class="row" *ngIf="quoteLineItem.extras.length > 0">
              <div class="col-sm-12">
                <div class="row">
                  <label class="col-sm-12 col-form-label">
                    Added extras:
                  </label>
                </div>
                <ng-container *ngFor="let extra of quoteLineItem.extras; let j = index">
                  <div class="row mb-2 extras-row">
                    <div class="col-sm-6 row-item-pad">
                      {{ extra.product }}
                    </div>
                    <div class="col-sm-2 row-item-pad">
                      {{ extra.quantity }}
                    </div>
                    <div class="col-sm-4">
                      <button class="primary-button icon-btn btn-color-delete" (click)="deleteExtra(extra, j)">
                        <span class="fa fa-trash" aria-hidden="true"></span>
                      </button>
                      <button class="primary-button icon-btn btn-color-primary edit" (click)="editExtra(extra, j)">
                        <span class="fa fa-pencil" aria-hidden="true"></span>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="row mt-1">
              <div class="col-sm-12 d-flex justify-content-center">
                <button type="button" class="btn btn-primary action-btn add" (click)="addOptionalExtra()">
                  <span>Add Extra</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center mt-3 mb-3" *ngIf="showOptionDescription && showTransport">
          <div class="col-sm-12 d-flex justify-content-center">
            <button type="button" class="btn btn-primary action-btn" (click)="addToCart()">
              <span>Add to Cart</span>
            </button>
          </div>
        </div>

      </ng-container>

    </form>
  </ng-template>


  <!-- Confirmation modal -->
  <tan-modal #removeUnitModal 
    [size]="'lg'" 
    [title]="'Please confirm'" 
    [showInformationBlock]="false"
    (onSave)="removeUnit()">
    <div modal-content>
      <div class="container">
        <ng-container *ngTemplateOutlet="confirmRemoveUnitContent;"></ng-container>
      </div>
    </div>
  </tan-modal>

  <ng-template #confirmRemoveUnitContent>
    <ng-container *ngIf="selectedModalLineItem != null && selectedModalLineItemExtra == null">
      <p>Are you sure you want to remove <b>{{selectedModalLineItem.rentalOption.name}}</b>?</p>
      <div class="mt-3">
        <label>Daily rate:</label><br>
        <span>{{selectedModalLineItem.rentalOption.dailyRate}}</span>
      </div>
      <div class="mt-3">
        <label>Monthly rate:</label><br>
        <span>{{selectedModalLineItem.rentalOption.monthlyRate}}</span>
      </div>
      <div class="mt-3">
        <label>Period requested:</label><br>
        <span>{{selectedModalLineItem.rentalOption.period.period}}</span>
      </div>
    </ng-container>
  </ng-template>


  <tan-modal #removeOptionalExtraModal [size]="'lg'" [title]="'Please confirm'" [showInformationBlock]="false"
    (onSave)="removeOptionalExtra()">
    <div modal-content>
      <div class="container">
        <ng-container *ngTemplateOutlet="confirmRemoveOptionalContent;"></ng-container>
      </div>
    </div>
  </tan-modal>

  <ng-template #confirmRemoveOptionalContent>
    <ng-container *ngIf="selectedModalLineItem != null &&selectedModalLineItemExtra != null">
      <p>Are you sure you want to remove <b>{{selectedModalLineItemExtra.product.name}}</b> from
        <b>{{selectedModalLineItem.name}}</b>?</p>
      <div class="mt-3">
        <label>Daily rate:</label><br>
        <span>{{selectedModalLineItemExtra.product.dailyRate}}</span>
      </div>
      <div class="mt-3">
        <label>Monthly rate:</label><br>
        <span>{{selectedModalLineItemExtra.product.monthlyRate}}</span>
      </div>
      <div class="mt-3">
        <label>Item:</label><br>
        <span>{{selectedModalLineItemExtra.product.item}}</span>
      </div>
    </ng-container>
  </ng-template>

  <tan-modal #editQuoteStatusModal [size]="'md'" [title]="'Edit Status'" [showInformationBlock]="false"
    (onSave)="saveUpdateQuote()">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(updateQuoteLoading$ | async)" [loadingText]="'<p>Updating Quote Status</p>'">
        </tan-loader>

        <div class="row justify-content-center" *ngIf="(updateQuoteError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not update Quote Status'"></tan-alert-message>
          </div>
        </div>

        <div class="row" *ngIf="!(updateQuoteError$ | async) && !(updateQuoteLoading$ | async)">
          <div class="col-sm-12">
            <div class="">
              <form class="mt-3" [formGroup]="editQuoteForm">

                <div class="form-group">
                  <label class="control-label" for="quote_status">Status</label>
                  <select class="form-control" formControlName="quote_status" id="quote_status"
                    (change)="setQuoteStatus()">
                    <option [ngValue]="null">Please select</option>
                    <option *ngFor="let status of quoteStatus" [ngValue]="status.id">{{ status.name }}</option>
                  </select>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>

  <tan-modal #editTransportChargeModal [size]="'md'" [title]="'Edit Charge'" [showInformationBlock]="false"
    (onSave)="updateTransportCharge()">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(createTransportChargeLoading$ | async)"
          [loadingText]="'<p>Creating transport charge</p>'">
        </tan-loader>
        <tan-loader [loading]="(updateTransportChargeLoading$ | async)"
          [loadingText]="'<p>Updating transport charge</p>'">
        </tan-loader>

        <div class="row justify-content-center" *ngIf="(createTransportChargeError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not create Transport Charge'">
            </tan-alert-message>
          </div>
        </div>
        <div class="row justify-content-center" *ngIf="(updateTransportChargeError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not update Transport Charge'">
            </tan-alert-message>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="form-check" *ngIf="canAddDiscount">
              <input class="form-check-input" type="radio" name="chargeChange" id="priceDiscount" value="priceDiscount"
                [checked]="priceDiscountChecked" (change)="setDiscount()">
              <label class="form-check-label" for="priceDiscount">
                Apply Discount
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="chargeChange" id="manualCharge" value="manualCharge"
                [checked]="manualChargeChecked" (change)="setManualCharge()">
              <label class="form-check-label" for="manualCharge">
                Create manual charge
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="">
              <form class="mt-3" [formGroup]="editChargeForm">

                <ng-container *ngIf="priceDiscountChecked">
                  <div class="form-group">
                    <label class="control-label" for="discount">Discount %</label>
                    <input type="text" class="form-control" formControlName="discount"
                      (ngModelChange)="updateDiscountAmount()" />
                    <span class="error" *ngIf="discountError">
                      Discount must be between 1 and 15</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="discount_amount">Discount Amount</label>
                    <input type="text" class="form-control" formControlName="discount_amount" />
                  </div>
                </ng-container>

                <ng-container *ngIf="manualChargeChecked">
                  <div class="form-group">
                    <label class="control-label" for="transport_charge">Charge</label>
                    <input type="text" class="form-control" formControlName="transport_charge" />
                  </div>

                  <div class="form-group">
                    <label class="control-label" for="transport_location">Location</label>
                    <input type="text" class="form-control" formControlName="transport_location" />
                  </div>

                  <div class="form-group">
                    <label class="control-label" for="load_size">Load size</label>
                    <input type="text" class="form-control" formControlName="load_size" />
                  </div>

                  <div class="form-group">
                    <label class="control-label" for="price">Price</label>
                    <input type="text" class="form-control" formControlName="price" />
                  </div>
                </ng-container>

              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </tan-modal>

  <tan-modal #editLineItemDiscountModal [size]="'md'" [title]="'Apply Discount'" [showInformationBlock]="false"
    (onSave)="updateLineItemDiscount()">
    <div modal-content>
      <div class="container">
        <tan-loader [loading]="(updateLineItemLoading$ | async)" [loadingText]="'<p>Applying discount</p>'">
        </tan-loader>

        <div class="row justify-content-center" *ngIf="(updateLineItemError$ | async)">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'error'" [message]="'Could not add discount'">
            </tan-alert-message>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="">
              <form class="mt-3" [formGroup]="editChargeForm">
                <div class="form-group">
                  <label class="control-label" for="discount">Discount %</label>
                  <input type="text" class="form-control" formControlName="discount"
                    (ngModelChange)="updateDiscountAmount()" />
                  <span class="error" *ngIf="discountError">
                    Discount must be between 1 and 15</span>
                </div>
                <div class="form-group">
                  <label class="control-label" for="discount_amount">Discount Amount</label>
                  <input type="text" class="form-control" formControlName="discount_amount" />
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
    </div>
  </tan-modal>

  <tan-modal #noDiscountAllowedModal [size]="'md'" [title]="'Not Allowed'" [showInformationBlock]="false"
    [showActionButton]="false">
    <div modal-content>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-sm-12 d-flex justify-content-center">
            <tan-alert-message [errorType]="'info'" [message]="'Discount has already been applied'">
            </tan-alert-message>
          </div>
        </div>
      </div>
    </div>
  </tan-modal>